import { render, staticRenderFns } from "./listParticipants.vue?vue&type=template&id=5f88dff8&scoped=true&"
import script from "./listParticipants.vue?vue&type=script&lang=js&"
export * from "./listParticipants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f88dff8",
  null
  
)

export default component.exports